// lbl.profile
export const profile = {
    firstname: {
        name: 'ชื่อ',
        placeholder: 'ชื่อ',
        required: 'กรุณากรอกชื่อ',
        too_short: 'กรุณาระบุตัวอักษรภาษาไทย หรืออังกฤษ {0} ตัวอักษรขึ้นไป',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: 'กรุณาระบุตัวอักษรภาษาไทย หรืออังกฤษ {0} ตัวอักษรขึ้นไป',
        invalid: '',
    },
    contactNumber: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: 'กรุณากรอกเบอร์โทรศัพท์',
        too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'อีเมล',
        required: 'กรุณากรอกอีเมล',
        too_short: '',
        invalid: 'อีเมลไม่ถูกต้อง',
    },
    idCard: {
        name: 'เลขบัตรประชาชน',
        placeholder: 'เลขบัตรประชาชน',
        required: 'เลขบัตรประชาชน',
        too_short: 'กรุณากรอกเลขบัตรประชาชน 13 หลัก',
        invalid: 'เลขบัตรประชาชนไม่ถูกต้อง',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: 'รหัสผ่าน',
        required: 'กรุณากรอกรหัสผ่าน',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'เพศ',
        placeholder: 'กรุณาเลือก',
        required: 'กรุณาเลือกเพศ',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'วันเกิด',
        placeholder: '',
        required: 'กรุณาเลือกวันเกิด',
        too_short: '',
        invalid: 'กรุณาเลือกใันที่ให้ถูกต้อง',
        date: {
            name: '',
            defaultText: 'วัน',
            placeholder: 'วัน',
            required: ' '
        },
        month: {
            name: '',
            placeholder: 'เดือน',
            defaultText: 'เดือน',
            required: ' '
        },
        year: {
            name: '',
            defaultText: 'ปี',
            placeholder: 'ปี',
            required: ' '
        },
    },
    zipcode: {
        name: 'รหัสไปรษณีย์',
        placeholder: 'รหัสไปรษณีย์',
        required: 'กรุณากรอกรหัสไปรษณีย์',
        too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
        invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
    },
    number: {
        name: 'บ้านเลขที่',
        placeholder: 'บ้านเลขที่',
        required: 'กรุณากรอกบ้านเลขที่',
        too_short: '',
        invalid: '',
    },
    soi: {
        name: 'ซอย',
        placeholder: 'ซอย',
        required: '',
        too_short: '',
        invalid: '',
    },
    road: {
        name: 'ถนน',
        placeholder: 'ถนน',
        required: '',
        too_short: '',
        invalid: '',
    },
    subdistrict: {
        name: 'แขวง/ตำบล',
        placeholder: 'กรุณาเลือกแขวง/ตำบล',
        required: 'กรุณาเลือกแขวง/ตำบล',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'เขต/อำเภอ',
        placeholder: 'กรุณาเลือกเขต/อำเภอ',
        required: 'กรุณาเลือกเขต/อำเภอ',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'จังหวัด',
        placeholder: 'กรุณาเลือกจังหวัด',
        required: 'กรุณาเลือกจังหวัด',
        too_short: '',
        invalid: '',
    },

    male: "ชาย",
    female: "หญิง",
    notspecified: "ไม่ระบุ",

    text_login: 'กรุณาเข้าสู่ระบบ<br/>เพื่อรับสิทธิพิเศษ',
    login: 'เข้าสู่ระบบ',

    text_page: {
        my_medal: 'เหรียญตราของฉัน',
        history: 'ประวัติการใช้งาน',
        helpchat: 'สอบถามออนไลน์',
        faq: 'คำถามที่พบบ่อย',
        contactus: 'ติดต่อเรา',
        privacy: 'รายละเอียดข้อมูลส่วนบุคคลของสมาชิก S Plus+',
        terms: 'ข้อตกลงและเงื่อนไข',
        personal_data_policy: 'นโยบายคุ้มครองข้อมูลส่วนบุคคล'
    },

    mobile_number: {
        name: 'การเปลี่ยนเบอร์โทรศัพท์',
        input_number_text: 'กรุณาระบุเบอร์โทรศัพท์ใหม่ เพื่อรับรหัส OTP<br/>เบอร์โทรศัพท์ปัจจุบันของคุณคือ',
        placeholder: 'กรุณาระบุเบอร์โทรศัพท์ใหม่',
        required: 'กรุณาระบุเบอร์มือถือใหม่ของคุณ 10 หลัก',
        too_short: 'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก <br/>และตัวแรกของเบอร์โทรศัพท์เท่ากับ 0',
        invalid: '',
    },
    otp: {
        name: 'กรุณาระบุรหัส OTP',
        request_otp: 'กดเพื่อรับรหัส OTP ทาง SMS',
        required: 'กรุณาระบุรหัส OTP',

        refcode_lbl: 'Ref.Code : ',
        time_left: 'เวลาที่เหลือ : ',

        time_left_text: 'รหัส OTP ของคุณหมดอายุแล้ว<br/>กรุณากดเพื่อรับรหัส OTP ใหม่',
    },
    error: {
        error409: 'คุณระบุเบอร์โทรศัพท์หมายเลขเดิม<br/>กรุณาระบุหมายเลขโทรศัพท์ใหม่'
    }

};
